import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { Link } from '@tanstack/react-router';

const NotFound: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 'calc(100vh - 65px)',
        textAlign: 'center',
        padding: 3,
      }}
      data-test-id="mwx-not-found"
    >
      <ErrorOutlineIcon
        sx={{ fontSize: 100, color: 'text.secondary', mb: 4 }}
      />
      <Typography variant="h1" component="h1" gutterBottom>
        404
      </Typography>
      <Typography variant="h4" component="h2" gutterBottom>
        Page Not Found
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: 'text.secondary',
          marginBottom: '16px',
        }}
      >
        The page you're looking for doesn't exist or has been moved.
      </Typography>
      <Link to="/">
        <Button variant="contained" color="primary" size="large">
          Go to Home
        </Button>
      </Link>
    </Box>
  );
};

export default NotFound;
